import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { buttonColor, onControlClick, cmsColorConfig, listOnSelect } from '../../JS/setColors'
import { TempChange, VDAStatusApi, setSelectedControlZone } from '../../action/roomControlAction'
import {
    setLightSceneAction, lightSceneIds,
    lightSceneLabels, zoneName
} from '../../config/constant'
import { setLightScene, setCurrentLightScene } from '../../action/roomControlAction'
import LightZoneSelector from './lightZoneSelector'

class LightControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SessionToken: localStorage.getItem("GuestJourneySessionToken"),
            zoneCount: 0
        }
    }
    componentDidMount() {
        let count = 0, lightZone;
        //buttonColor(this.props.menuColor);
        // onControlClick(this.props.currentLightscene, "lightMood", this.props.menuColor);
        cmsColorConfig(this.props.menuColor);
        listOnSelect(this.props.menuColor);
        if (this.props.VDAZoneList.length > 0) {
            this.props.VDAZoneList.map((iterator) => {
                if (iterator.lightCount > 0)
                    count++;
                lightZone = iterator
            })
            if (count === 1) {
                this.props.setSelectedControlZone(lightZone);
                this.setState({ zoneCount: 1 });
            }
        }

    }

    VDAStatusCallBack = (status) => {
        this.props.lightScreens.map((iterator, index) => {
            if (index < 7) {
                if (iterator.value === "ON") {
                    this.props.setCurrentLightScene(`light${iterator.id}`);
                    //onControlClick(`light${iterator.id}`, "lightMood", this.props.menuColor);
                }
                // for (let i = 0; i < this.props.lightScreens.length; i++) {
                //     if (this.props.lightScreens[i][`light${index + 1}`]) {
                //         if (this.props.lightScreens[i][`light${index + 1}`].value === "ON") {
                //             this.props.setCurrentLightScene(`light${index + 1}`);
                //             onControlClick(`light${index + 1}`, "lightMood", this.props.menuColor);
                //         }
                //     }
                // }
            }
        })
    }

    VDAApiCall = () => {
        //we have set this time out to make sure that we hit the status API after we hit the sendCommand
        window.setTimeout(() => {
            //console.log("this.state.SessionToken", this.state.SessionToken);
            this.props.VDAStatusApi(
                this.state.SessionToken, this.props.guestDetail,
                this.VDAStatusCallBack, zoneName
            );
        }, 3000);
    }

    buttonClick = (id, mode, lightScreen, zone) => {
        listOnSelect(this.props.menuColor);
        //onControlClick(id, mode, this.props.menuColor);
        this.props.setLightScene(
            id, setLightSceneAction, id,
            this.props.guestDetail, this.props.menuColor,
            zone
        );
        this.props.setCurrentLightScene(`light${zone}${lightScreen.id}`);
        console.log("id", `light${zone}${lightScreen.id}`);
        //this.VDAApiCall();
    }

    componentDidUpdate(prePro) {
        listOnSelect(this.props.menuColor);
    }
    componentWillUnmount() {
        this.props.setSelectedControlZone({});
    }
    backButton = () => {
        this.props.setSelectedControlZone({});
    }
    render() {
        return (
            <div id="controls-light"
                className="rc-controls w-100">
                <LightZoneSelector />
                <div style={this.props.selectedControlZone.zoneId ? {} : { display: "none" }}>
                    <button class="return-button"
                        data-target="ac-selection"
                        style={this.props.VDAZoneList.length === 1 || this.state.zoneCount === 1 ? { display: "none" } : {}}
                        onClick={() => { this.backButton() }}>Back to selection</button>
                    {/* <h2>Light controls</h2> */}
                    {
                        // this.props.VDAZoneList.map((iter, index) => {
                        //     return (
                        this.props.selectedControlZone.lightScenes ?
                            this.props.selectedControlZone.lightScenes.map((iterator, lightIndex) => {
                                if (lightIndex < this.props.selectedControlZone.lightCount) {
                                    //console.log("iterator", lightIndex, iter.lightCount);
                                    return (
                                        <button id={`light${this.props.selectedControlZone.zoneId}${iterator.id}`}
                                            onClick={() => { this.buttonClick(`light${iterator.id}`, "lightMood", iterator, this.props.selectedControlZone.zoneId) }}
                                            className={
                                                this.props.currentLightscene === `light${this.props.selectedControlZone.zoneId}${iterator.id}` ?
                                                    "button w-100 selected" : "button w-100"
                                            }>
                                            {iterator.label ? iterator.label : "light"}
                                        </button>
                                    )
                                }
                                //     })
                                // )
                            }) : null

                    }
                </div >
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor,
        currentLightscene: state.store.roomControl.currentLightscene,
        lightScreens: state.store.roomControl.lightScreens,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        selectedControlZone: state.store.roomControl.selectedControlZone
    }
}

export default connect(
    mapStateToProps,
    {
        setLightScene,
        setCurrentLightScene,
        VDAStatusApi,
        setSelectedControlZone
    }
)(LightControl);
